<template>
	<div class="authenticated-file-link">
		<v-progress-circular v-if="loading" indeterminate size="20" width="2" />
		<a v-else-if="!error" href="#" @click.prevent="openFile">{{ $t('Посмотреть') }}</a>
		<span v-else class="text--secondary">{{ $t('Не удалось загрузить файл') }}</span>
	</div>
</template>

<script>
	export default {
		props: {
			url: {
				type: String,
				required: true,
			},
		},
		data: () => ({
			loading: false,
			blobUrl: null,
			error: false,
		}),
		beforeDestroy() {
			this.revokeBlobUrl();
		},
		watch: {
			url() {
				this.revokeBlobUrl();
				this.error = false;
			},
		},
		methods: {
			revokeBlobUrl() {
				if (this.blobUrl) {
					URL.revokeObjectURL(this.blobUrl);
					this.blobUrl = null;
				}
			},
			async ensureBlobUrl() {
				if (this.blobUrl) {
					return this.blobUrl;
				}
				if (!this.url) {
					return null;
				}
				this.loading = true;
				this.error = false;
				try {
					const response = await this.$http.get(this.url, {
						responseType: 'blob',
						silent: true,
					});
					this.blobUrl = URL.createObjectURL(response.data);
					return this.blobUrl;
				} catch (loadError) {
					console.error('Ошибка загрузки файла:', loadError);
					this.error = true;
					return null;
				} finally {
					this.loading = false;
				}
			},
			async openFile() {
				const url = await this.ensureBlobUrl();
				if (url) {
					window.open(url, '_blank');
				}
			},
		},
	};
</script>
